import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=477c4578&scoped=true&"
import script from "./Stories.vue?vue&type=script&lang=js&"
export * from "./Stories.vue?vue&type=script&lang=js&"
import style0 from "./Stories.vue?vue&type=style&index=0&id=477c4578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c4578",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLinkSocial: require('/app/components/storyblok/ui/LinkSocial.vue').default,BaseChatItem: require('/app/components/base/ChatItem.vue').default})
